<template>
  <div>
    <CContainer>
      <CCard>
        <CCardBody>
          <CForm class="w-100">
            <CRow>
              <CCol :sm="6">
                <div class="mb-3">
                  <p class="input-label mt-3">Product Name <span>(avoid using "-" or "/" on product name)</span></p>
                  <CInput valid-feedback="Input is valid." invalid-feedback="Please provide a valid product name."
                    v-model="productName" :is-valid="productNameValidator" />
                  <p class="input-label mt-3">Chinese Name</p>
                  <CInput v-model="chineseName" placeholder="Input chinese name (optional)"/>
                  <p class="input-label mt-3">Price</p>
                  <CInput valid-feedback="Input is valid." invalid-feedback="Please provide numeric value."
                    v-model="price" :is-valid="priceValidator">
                    <template #prepend-content>RM</template>
                  </CInput>

                  <div>
                    <p class="input-label mt-3">Category</p>
                    <CDropdown color="light" :toggler-text="selectedCategory" class="mt-2 dropdown-full-width">
                      <CDropdownItem class="dropdown-full-width" v-for="category in categoryOptions" :key="category.id"
                        @click="onChangeCategory($event, category.id, category.sub_categories)">
                        {{ category.category_name }}
                      </CDropdownItem>
                    </CDropdown>

                    <div v-if="subCategory.length">
                      <p class="input-label mt-3">Sub Category</p>
                      <CDropdown color="light" :toggler-text="selectedSubCategory" class="mt-2 dropdown-full-width">
                        <CDropdownItem class="dropdown-full-width" v-for="(subCategory, index) in subCategory"
                          :key="index" @click="onChangeSubCategory($event, subCategory)">
                          {{ subCategory }}
                        </CDropdownItem>
                      </CDropdown>
                    </div>
                  </div>

                  <div>
                    <p class="input-label mt-3">Product Image</p>
                    <CCard>
                      <CCardBody>
                        <CAlert class="mb-0" color="warning">
                          <ul class="mb-0">
                            <li>Aspect ratio: 4:5</li>
                            <li>Max image size: 2Mb</li>
                          </ul>
                        </CAlert>
                        <image-uploader class="mt-4" v-model="productImg" :inputTextHelper="'+'" :isSmall="true"
                          :isEdit="isEdit" />
                      </CCardBody>
                    </CCard>
                  </div>

                </div>
              </CCol>
              <CCol :sm="6">

                <div>
                  <p class="input-label mt-3">Color</p>
                  <CCard>
                    <CCardBody>
                      <CRow>
                        <CCol :sm="6" v-for="color in colorOptions" :key="color.id">
                          <CInputCheckbox :label="color.color_name" @click="onChangeColor($event, color)" />
                        </CCol>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </div>

                <div>
                  <p class="input-label mt-3">Occasion</p>
                  <CCard>
                    <CCardBody>
                      <CRow>
                        <CCol :sm="6" v-for="occasion in occasionOptions" :key="occasion.id">
                          <CInputCheckbox :label="occasion.occasion_name" @click="onChangeOccasion($event, occasion)" />
                        </CCol>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </div>
                <div>
                  <p class="input-label mt-3">Size</p>
                  <CCard>
                    <CCardBody>
                      <CRow>
                        <CCol :sm="6" v-for="(size, index) in availableSize" :key="index">
                          <CInputCheckbox :label="size.size" @click="onChangeSize($event, size, index)" />
                          <CInput v-model="size.price" :disabled="!size.checked" placeholder="Insert Price">
                            <template #prepend-content>RM</template>
                          </CInput>
                        </CCol>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </div>
              </CCol>
            </CRow>
            <CRow class="mt-5">
              <CCol md="12">
                <CButton @click.prevent="handleCreate" color="success">
                  Create
                </CButton>
                <CButton class="ml-3" @click.prevent="onCancel" color="secondary">
                  Cancel
                </CButton>
              </CCol>
            </CRow>
          </CForm>
        </CCardBody>
      </CCard>
    </CContainer>
  </div>
</template>

<script>
import {
  COLOR_GET,
  CATEGORY_GET,
  OCCASION_GET,
  PRODUCT_CREATE,
} from '../../../../constants/api'

import axios from 'axios'

import { VueEditor } from 'vue2-editor'
import ImageUploader from '../../../components/ImageUploader'
import { validateSelectedSizes } from '../../../../utils/helper'

export default {
  components: { VueEditor, ImageUploader },

  data() {
    return {
      productImg: '',
      availableSize: [
        {
          size: 'S',
          price: null,
          checked: false
        },
        {
          size: 'M',
          price: null,
          checked: false
        },
        {
          size: 'L',
          price: null,
          checked: false
        },
        {
          size: 'XL',
          price: null,
          checked: false
        },
        {
          size: 'XXL',
          price: null,
          checked: false
        },
      ],
      text: '',
      initialText: '',
      accessToken: sessionStorage.getItem('access_token') || '',
      validatePass: {
        productName: false,
        price: false,
        colorId: false, // tbdel
        categoryId: false, // new
        selectedCategory: false,
        selectedOccasion: false,
      },
      isEdit: true,
      colorOptions: [],
      categoryOptions: [],
      occasionOptions: [],
      selectedCategory: 'Select Category',
      subCategory: [],

      productName: '',
      chineseName: '',
      price: 0,
      categoryId: '',
      selectedColor: [],
      selectedOccasion: [],

      selectedSubCategory: '',
    }
  },

  beforeMount() {
    this.fetchOptions()
  },

  computed: {
    isValidatePass() {
      return (
        this.validatePass.productName &&
        this.validatePass.price &&
        this.validatePass.categoryId &&
        this.validatePass.selectedColor &&
        this.validatePass.selectedOccasion
      )
    },
  },

  methods: {
    fetchOptions() {
      // fetch all occasions, categories and colors
      const getColor = axios.get(COLOR_GET)
      const getCategory = axios.get(CATEGORY_GET)
      const getOccasion = axios.get(OCCASION_GET)
      axios
        .all([getColor, getCategory, getOccasion])
        .then(
          axios.spread((...res) => {
            this.colorOptions = res[0].data.data
            this.categoryOptions = res[1].data.data
            this.occasionOptions = res[2].data.data
          })
        )
    },

    handleCreate() {
      if (!this.productImg) return alert('Please upload an image!')

      const newAvailableSize = this.availableSize.filter(size => size.checked).map(({size, price}) => ({size, price}))
      if (!validateSelectedSizes(newAvailableSize)) {
        return alert("Selected size price must be valid and should not be empty.")
      }

      const payload = {
        name: this.productName,
        chinese_name: this.chineseName,
        price: this.price,
        categoryId: this.categoryId,
        subCategory: this.selectedSubCategory,
        colors: JSON.stringify(this.selectedColor),
        occasions: JSON.stringify(this.selectedOccasion),
        availableSize: JSON.stringify(newAvailableSize),
        image: [this.productImg],
      }

      const checkPayload = {
        name: payload.name,
        price: payload.price,
        categoryId: payload.categoryId,
        occasions: payload.occasions,
        image: payload.image,
      }

      if (payload.subCategory) {
        checkPayload.subCategory = payload.subCategory
      }

      for (const key in checkPayload) {
        if (
          (payload[key] === '' ||
            payload[key] === '[]' ||
            payload[key] === 0 ||
            payload[key] === undefined ||
            payload[key] === null)
          && key !== 'boxColors'
        ) {
          return alert(`Please select ${key}`)
        }
      }
      axios
        .post(PRODUCT_CREATE, payload, {
          headers: {
            'x-access-token': this.accessToken,
          },
        })
        .then(() => {
          this.$router.push({ path: `/product` })
        })
        .catch(err => {
          console.log(err)
        })
    },

    priceValidator(val) {
      if (!isNaN(val)) {
        this.validatePass.price = true
        return true
      } else {
        this.validatePass.price = false
        return false
      }
    },

    productNameValidator(val) {
      if (val.length > 0 && !/[-\/]/.test(val)) {
        this.validatePass.productName = true
        return true
      } else {
        this.validatePass.productName = false
        return false
      }
    },

    onChangeCategory(event, id, subCategory) {
      this.selectedCategory = event.target.innerText
      this.categoryId = id

      if (subCategory.length) {
        this.subCategory = subCategory
        this.selectedSubCategory = subCategory[0]
      } else {
        this.subCategory = []
      }
    },

    onChangeSubCategory(event) {
      this.selectedSubCategory = event.target.innerText
    },

    onChangeColor(event, color) {
      const isChecked = event.target.checked
      if (isChecked) {
        this.selectedColor.push(color)
      } else {
        this.selectedColor = this.selectedColor.filter(e => { return e.color_name !== color.color_name })
      }
    },

    onChangeOccasion(event, occasion) {
      const isChecked = event.target.checked
      if (isChecked) {
        this.selectedOccasion.push(occasion)
      } else {
        this.selectedOccasion = this.selectedOccasion.filter(e => { return e.occasion_name !== occasion.occasion_name })
      }
    },

    onChangeSize(event, size, index) {
      const isChecked = event.target.checked
      if (isChecked) {
        this.availableSize[index].checked = true
      } else {
        this.availableSize[index].checked = false
      }
    },

    onCancel() {
      this.$router.push({ path: `/product` })
    },
  },
}
</script>

<style scoped>
.button-text {
  align-items: center;
  display: flex;
  justify-content: center;
}

.button-text>span {
  margin-left: 6px;
}

.input-label {
  margin-bottom: 0.5rem;
  font-weight: bold;
}
.input-label span {
  font-size: 12px;
  font-weight: normal;
  font-style: italic;
}

.image-input-label {
  font-weight: bold;
  margin: 1rem 0 0 0;
}

.dropdown-full-width {
  width: 100%;
}
</style>